import { Component, EventEmitter, Input, Output, ViewChild } from "@angular/core";
import { WizardComponent } from "angular-archwizard";
import { AppointmentData, InvalidResourceTime } from "src/classes/Diary/Appointment";
import { Service } from "src/classes/Diary/DepartmentsServices";
import { CreateAppServiceComponent } from "../create-app-service/create-app-service.component";
import { CustomerAppointment } from "src/classes/Diary/CustomerAppointment";
import { CreateAppCustomerComponent } from "../create-app-customer/create-app-customer.component";
import { MbscSelectData, Notifications } from "@mobiscroll/angular";
import { CreateAppSummaryComponent } from "../create-app-summary/create-app-summary.component";
import { Config, ConfigDiary } from "src/classes/Common/ConfigData";
import { CreateAppAbsenceComponent } from "../create-app-absence/create-app-absence.component";

type Resource = {
    id: number;
    name: string;
    imagePath: string;
};

@Component({
    selector: "app-create-appointment",
    templateUrl: "./create-appointment.component.html",
    styleUrls: ["./create-appointment.component.css"]
})
export class CreateAppointmentComponent {
    /// !!! Please respect the data exchange mechanism between components

    @Input() appDataTemp: AppointmentData;
    @Input() holidayName: string;
    @Input() resources: MbscSelectData[] | Resource[];
    @Input() config: Config;
    @Input() configDiary: ConfigDiary;
    @Input() invalid: InvalidResourceTime[];
    @Input() isEditingEvent: boolean;

    @Output() newItemAppointment: EventEmitter<AppointmentData> = new EventEmitter<AppointmentData>();

    eventTitle: string = "";

    isEditHours: boolean = false;
    isErrorVisible: boolean = false;

    isAppointorErrorVisible: boolean = false;

    isLeavedSummary: boolean = false;

    @ViewChild(WizardComponent, { static: false }) wizard: WizardComponent;
    @ViewChild(CreateAppServiceComponent, { static: false }) appCreateService: CreateAppServiceComponent;
    @ViewChild(CreateAppCustomerComponent, { static: false }) appCreateCustomer: CreateAppCustomerComponent;
    @ViewChild(CreateAppSummaryComponent, { static: false }) appCreateSummary: CreateAppSummaryComponent;
    @ViewChild(CreateAppAbsenceComponent, { static: false }) appCreateAbsence: CreateAppAbsenceComponent;

    constructor(
        private notifications: Notifications
    ) { }

    // Function that works on the opening of the popup
    initialize(): void {
        // If the resources are not yet converted to the Resource type, convert them
        if ((this.resources as MbscSelectData[]).every((resource: MbscSelectData) => resource.value != undefined)) {
            this.resources = (this.resources as MbscSelectData[]).map((resource: MbscSelectData): Resource => ({
                id: +resource.value,
                name: resource.text,
                imagePath: resource.imagePath
            }));
        }

        this.isEditHours = false;
        this.isErrorVisible = false;
        this.isAppointorErrorVisible = false;
        this.isLeavedSummary = false;

        // If the event is being edited, go to the final step, else go to the first step
        if (this.isEditingEvent) {
            setTimeout(() => {
                if (this.appDataTemp.absenceId) {
                    this.appCreateAbsence.initialize();
                    this.wizard.goToStep(3);
                }
                else {
                    this.appCreateSummary.initialize(false);
                    this.wizard.goToStep(2);
                }
            }, 0);
        }
        else {
            this.appCreateCustomer.initialize();
            this.wizard.goToStep(0);
        }
    }

    // Function that works on the closing of the service step
    leaveServices(): void {
        this.notifications.confirm({
            title: "אזהרה",
            message: "שימו לב ששינוי לקוח/ה בתור קיים יגרום לאיפוס כל המידע המקורי של התור (הטיפולים, ההערות וכו’). האם להמשיך?",
            cssClass: "event-services-close-popup",
            cancelText: "לא להמשיך",
            okText: "כן, להמשיך",
            onClose: (result: boolean) => {
                if (result) {
                    if (this.isEditingEvent) {
                        this.appCreateCustomer.initialize(true);
                    }
                    else {
                        this.appCreateCustomer.initialize(false);
                    }

                    this.appDataTemp.subserv = [];

                    this.wizard.goToPreviousStep();
                }
            }
        });
    }

    // Function that selects the customer
    onChangeCustomer(customer: CustomerAppointment): void {
        this.appDataTemp.customerapp = customer;

        this.appCreateService.initialize(true);

        this.wizard.goToNextStep();
    }

    // Function that toggle the service
    onServiceToggle(toggledService: Service): void {
        if (this.appDataTemp.subserv.map((service: Service): number => service.serviceId).includes(toggledService.serviceId)) {
            this.appDataTemp.subserv.splice(this.appDataTemp.subserv.findIndex((service: Service) => service.serviceId == toggledService.serviceId), 1);
        }
        else {
            this.appDataTemp.subserv.push(toggledService);
        }
    }

    // Function that works on the closing of the summary step
    leaveSummary(): void {
        this.isAppointorErrorVisible = false;

        if (this.isEditingEvent && !this.isLeavedSummary) {
            this.appCreateService.initialize(true);
            this.isLeavedSummary = true;
        }
        else {
            this.appCreateService.initialize(false);
        }
    }

    // Initialize the absence step
    absenceInitialize(): void {
        this.appCreateAbsence.initialize();
    }

    // Initialize the summary step
    summaryInitialize(): void {
        this.appCreateSummary.initialize();
    }

    // Toogles the "isEditHours" variable
    isEditHoursChange(isEditHours: boolean): void {
        this.isEditHours = isEditHours;

        if (!isEditHours) {
            this.isErrorVisible = false;
        }
    }

    // Save data to server
    finishFunction(): void {
        if (this.isEditHours) {
            this.isErrorVisible = true;
        }
        else if (!this.appDataTemp.appointorId && this.appDataTemp.isMustMadeAppoinment && this.wizard.currentStepIndex == 2) {
            this.isAppointorErrorVisible = true;
            this.appCreateSummary.scrollToAppointor();
        }
        else {
            this.addNewItemAppointment(this.appDataTemp);
        }
    }

    // Function that uses the emmiter to add a new item in the parent component
    addNewItemAppointment(value: AppointmentData): void {
        this.newItemAppointment.emit(value);
    }
}